import { useFormikContext } from 'formik'
import {
  Button,
  Switch,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

import { EAccountSubscriptionPlans, ETranslationNs, ISubscriptionPriceForm } from 'src/types'
import { HelperWrapper } from 'src/components/helper-wrapper'

import { useStyles } from '../../styles'

export const PriceForm = () => {
  const [t] = useTranslation([ETranslationNs.Common, ETranslationNs.Form])
  const { errors, values, handleChange, isSubmitting, dirty, setFieldValue } =
    useFormikContext<ISubscriptionPriceForm>()

  const classes = useStyles()

  const handleSubscriptionChange = (_: any, newSubscription: EAccountSubscriptionPlans) => {
    if (newSubscription !== null) {
      setFieldValue('type', newSubscription)
    }
  }

  const handleMonthsChange = (_: any, newMonths: number) => {
    if (newMonths !== null) {
      setFieldValue('months', newMonths)
    }
  }

  const handleDefaultChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue('default', event.target.checked)
  }

  return (
    <div className={`${classes.formWrapper} ${classes.formWrapperWithHeight}`}>
      <div className={classes.inputsWrapper}>
        <Typography className={classes.title}>
          <HelperWrapper t="subscription-price-create-title" />
        </Typography>
        <div className={classes.inputsWrapper}>
          <div className={classes.itemWrapper}>
            <Typography className={classes.itemTitle}>
              <HelperWrapper t="subscribe-form-duration" />
            </Typography>
            <ToggleButtonGroup
              color="primary"
              exclusive
              value={values.months}
              onChange={handleMonthsChange}
            >
              <ToggleButton value={1}>
                1&nbsp;
                <HelperWrapper t="subscription-month-text" />
              </ToggleButton>
              <ToggleButton value={12}>
                12&nbsp;
                <HelperWrapper t="subscription-months-text" />
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
          <div className={classes.itemWrapper}>
            <Typography className={classes.itemTitle}>
              <HelperWrapper t="subscribe-form-plan" />
            </Typography>
            <ToggleButtonGroup
              color="primary"
              exclusive
              value={values.type}
              onChange={handleSubscriptionChange}
            >
              <ToggleButton value={EAccountSubscriptionPlans.plus}>Plus</ToggleButton>
              <ToggleButton value={EAccountSubscriptionPlans.premium}>Premium</ToggleButton>
            </ToggleButtonGroup>
          </div>
          <TextField
            autoComplete="off"
            variant="standard"
            id="amount"
            name="amount"
            onChange={handleChange}
            type="number"
            label={t('amount-input-label.v') + ' (USD)*'}
            value={values.amount}
            helperText={
              <Typography className={classes.warningText}>
                {errors.amount && <HelperWrapper t={errors.amount} />}&nbsp;
              </Typography>
            }
          />
          <Typography>{t('default-input-label.v')}</Typography>
          <Switch
            name="default"
            checked={values.default}
            onChange={handleDefaultChange}
            id="default"
          />
        </div>
      </div>
      <Button variant="contained" disabled={isSubmitting || !dirty} type="submit">
        <HelperWrapper t="save-button-text" />
      </Button>
    </div>
  )
}
